import store from '../store/index'

//------------------------
// clear campaign combatants
//------------------------
export default async function useClearCampaignCombatants(arena_slug) {
  return new Promise((resolve, reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store
    //------------------
    // clear combatants
    //------------------
    this_store
      .dispatch('combat/clearCampaignCombatants', arena_slug)
      .then(() => {
        console.log('returning to main 2...')
        resolve()
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        reject(err)
      })
  })
}
